export class DomComponentHander {
    static Load() { }
    ;
    static DomContentLoaded() { }
    ;
}
